import { ActionType } from 'typesafe-actions'
import {
  RESULTS_SUMMARY_COMPLETED,
  UPDATE_DATE_FILTER_RANGE,
  TOURN_WIN_LOSS_REQUESTED,
  TOURN_WIN_LOSS_COMPLETED,
  TOURN_WIN_LOSS_FAILED,
  TOURNAMENT_GRAPH_YEAR_FILTER_UPDATED,
  TOURNAMENT_GRAPH_GAME_TYPE_FILTER_UPDATED,
} from 'actions/results-actions'
import * as actions from 'actions/results-actions'
import { MatchUpStatBucket, MatchUpTypeEnum } from 'types/global'
import { GameType } from 'components/chart/ResultsDoughnutChart/ResultsDoughnutChartTypes'

type ResultsAction = ActionType<typeof actions>

type State = Readonly<{
  resultsSummary: any
  dateFilter: number | null
  tournWinLossLoading: boolean
  tournWinLoss: MatchUpStatBucket[]
  tournWinLossYearFilter?: number
  tournWinLossGameTypeFilter?: GameType
}>

const initialState: State = {
  resultsSummary: {},
  dateFilter: null,
  tournWinLossLoading: true,
  tournWinLoss: [],
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: ResultsAction) {
  switch (action.type) {
    case RESULTS_SUMMARY_COMPLETED:
      return { ...state, resultsSummary: action.payload }
    case UPDATE_DATE_FILTER_RANGE:
      return { ...state, dateFilter: action.payload }
    case TOURN_WIN_LOSS_REQUESTED:
      return { ...state, tournWinLossLoading: true }
    case TOURN_WIN_LOSS_FAILED:
      return { ...state, tournWinLossLoading: false }
    case TOURN_WIN_LOSS_COMPLETED:
      return { ...state, tournWinLossLoading: false, tournWinLoss: action.payload }
    case TOURNAMENT_GRAPH_YEAR_FILTER_UPDATED:
      return { ...state, tournWinLossYearFilter: action.payload }
    case TOURNAMENT_GRAPH_GAME_TYPE_FILTER_UPDATED:
      return { ...state, tournWinLossGameTypeFilter: action.payload }
    default:
      return state
  }
}
